export default "__VITE_ASSET__xK3b9KbU__"